import { Component } from 'src/utils';
import info from './../../../images/question.png';
import homeArrow from './../../../images/home-arrow.png';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import template from './guestCart.html';
import closeIcon from './../../../images/close.png';
import alertIcon from './../../../images/alert.png';
import shippingOfferInfoIcon from './../../../images/shipping-info.png';
import shippingOfferAvailableIcon from './../../../images/shipping-tick.png';

@Component({
  controllerAs: 'guestCart',
  template
})

export default class guestCart {

  static $inject = [
    '$scope',
    '$rootScope',
    '$ngRedux',
    'spinnerService',
    'authService',
    'orderService',
    '$state',
    '$uibModal',
    '$timeout',
    '$window',
    '$stateParams',
    'APP',
    'toaster'
  ];

  constructor($scope, $rootScope, $ngRedux, $spinner, $auth, $order, $state, $uibModal, $timeout, $window, $stateParams, APP, toaster) {
    const disconnect = $ngRedux.connect(this.mapState)(this);
    this.dscMasterCode = '88888888'; // Named constant
    this.$window = $window;
    this.APP = APP;
    this.$auth = $auth;
    this.$state = $state;
    this.$order = $order;
    this.$scope = $scope;
    this.$uibModal = $uibModal;
    this.homeArrow = homeArrow;
    this.$stateParams = $stateParams;
    this.$rootScope = $rootScope;
    this.$spinner = $spinner;
    this.$toaster = toaster;
    this.info = info;
    // Icons
    this.logoIcon = logoIcon;
    this.houseIcon = houseIcon;
    this.closeIcon = closeIcon;
    this.alertIcon = alertIcon;
    this.shippingOfferInfoIcon = shippingOfferInfoIcon;
    this.shippingOfferAvailableIcon = shippingOfferAvailableIcon;
    // Variables
    this.shippingOffer = {};
    this.shippingOffer.thresholdAmount = 1500;
    this.shippingOffer.isOfferEligible = false;
    this.discountType = null;
    this.isMiscelleneousCategory = 4;
    this.giftCardMasterCodeStartsWith = '9';
    this.isErplyStore = false;
    this.promoLengthToBeShown=25;
    this.numberOfItemsAllowedToPurchase = 40;
    $window.scrollTo(0, 0);
    this.currencyType = 'USD';
    $spinner.show('appSpinner');
    if (this.$auth.isGuestLogin()) {
      // Getting Session Guest cart details
      $auth.getGuestCart();

      // End Saving Guest User and cart in Guest DB--------------------------------
      // const guestUser = this.$auth.getGuestUser();
      // this.$auth.getGuestUserById(guestUser.guestUserId).then(success => {
      //   $spinner.hide('appSpinner');
      // },
      //   error => {
      //     $spinner.hide('appSpinner');
      //   });
      // End Saving Guest User and cart in Guest DB--------------------------------
      // if (this.guestCartList && this.guestCartList.length) {
      // const user = {
      //   role: 7, // Guest User Role
      //   storeURLName: store ? store.storeName : null,
      //   cartTotalItems: this.guestCartList.length ? this.guestCartList.map(data => data.quantity).reduce((total, data) => total + data) : 0
      // };
      // this.$auth.saveGuestUser(user).then(success => {
      //   this.$auth.addGuestUser(success.data.userId, success.data.ipaddress);
      //   $spinner.hide('appSpinner');
      // }, error => {
      //   $spinner.hide('appSpinner');
      // });
      // } else {
      $spinner.hide('appSpinner');
      // }
      if ($stateParams.storeName && $stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
        this.storeName = $stateParams.storeName;
      } else {
        this.storeName = this.$auth.getGuestStoreDetail().storeName;
      }
      this.$auth.getStoreDetail(this.storeName).then(success => {
        if (this.storeDetail) {
          if (this.storeDetail.hasErply) {
            this.isErplyStore = true;
          }
          $timeout(() => {
            this.country = this.storeDetail.country.countryCode ? this.storeDetail.country.countryCode : 'US';
            this.currencyType = $order.getCurrencyType(this.country);
          }, 500);
        }
      })
      .catch(err => {
        this.$auth.printCustomerGenericLogs(err);
      })
      .finally(() => {
        // Gettig Guest cart Details
        this.getGuestCartDetails();
      });

    }
    $scope.$on('$destroy', disconnect);
  }
  mapState(state) {
    return {
      profile: state.auth.profile,
      detail: state.order.cartDetail,
      storeDetail: state.auth.storeDetail,
      discountCoupon: state.order.discountCoupon,
      coupon: state.order.coupon,
      storeDiscountMap: state.order.storeDiscountMap,
      orderPoints: state.order.orderPoints,
      guestCartList: state.auth.guestCartList,
      isAnyItemInactive: state.order.cartDetail && state.order.cartDetail.cartItems ? state.order.cartDetail.cartItems.find(item => !(item.item.isActive
        && item.item.masterProduct.isActive && (item.item.price >= item.item.regionalPrice) && !item.item.isOutOfStock)) : false
    };
  }

  getGuestCartDetails() {
    this.$spinner.show('appSpinner');
    this.$order.getGuestCartDetail(this.createGuestCartRequest())
      .then(success => {
        this.$spinner.hide('appSpinner');
        if (this.detail && this.detail.shopCartResponse) {
          this.discountType = this.detail.shopCartResponse.promoCode;
        }
        if (this.detail && this.detail.cartItems && this.detail.cartItems.length && this.guestCartList) {
          this.guestCartList.forEach(ele => {
            if (ele && ele.itemId && !this.detail.cartItems.find(item => ele.itemId === item.item.id)) {
              this.$auth.removetoGuestCart(ele.itemId);
              this.$auth.getGuestCart();
            }
          });
          if (this.detail.cartItems.length > this.guestCartList.length) {
            this.detail.cartItems.forEach(ele => {
              if (ele && ele.item && !this.guestCartList.find(item => item.itemId === ele.item.id)) {
                this.$auth.addtoGuestCart({
                  'quantity': ele.quantity, 'itemId': ele.item.id,
                  'subCategoryId': ele.subCategory.id, 'categoryId': ele.subCategory.category.id, 'masterProductId': ele.item.masterProduct.id
                });
              }
            });
          }
          this.erplyDis = [];
          var dis = {};
          var ctrl = this;
          if (ctrl.detail.promotionsAppliedOnItems) {
            angular.forEach(ctrl.detail.promotionsAppliedOnItems, function (id, value) {
              angular.forEach(ctrl.detail.cartItems, function (item) {
                if (item.item.masterProduct.masterCode == value) {
                  item.item.promotionsAppliedOnItems = id;
                }
              });
            });
            console.log(this.detail.cartItems);
          }
          var i = 0;
          angular.forEach(this.detail.erplyPromoAndDiscount, function (item, key) {
            dis = {};
            console.log('key', key);
            console.log('item', item);
            dis.key = key;
            dis.value = item;
            dis.sortId = i+1;
            i=i+1;
            ctrl.erplyDis.push(dis);
          });
        }
      })
      .catch(err => {
        this.$auth.printCustomerGenericLogs(err);
      })
      .finally(() => {
        this.$spinner.hide('appSpinner');
      });
  }

  createGuestCartRequest() {
    const cartData = this.guestCartList.filter(data => !data.isDscCard);
    const guestCartDeliveryRequest = sessionStorage.getItem('GuestCartRequest') ? JSON.parse(sessionStorage.getItem('GuestCartRequest')) : null;
    var appliedPromoCoupon = [];
    if(sessionStorage.getItem('discountCoupon')) {
      appliedPromoCoupon = sessionStorage.getItem('discountCoupon').split(',');
    } 
    if (guestCartDeliveryRequest && guestCartDeliveryRequest.guestCartItems && guestCartDeliveryRequest.guestCartItems.length > 0) {
      guestCartDeliveryRequest.guestCartItems = [...cartData];
      return guestCartDeliveryRequest;
    } else {
      return {
        isGuest: true,
        deliveryType: 'In Store Pickup',
        shipTo: null,
        manualPromotionIDs: appliedPromoCoupon,
        guestCartItems: cartData
      };
    }
  }

  proceedToCheckout() {

    var activeCartItems = this.guestCartList?this.guestCartList:[];
    if(this.numberOfItemsAllowedToPurchase < activeCartItems.length) {
      var detailInfo = "An order can have a maximum of 40 items. Please remove some items from the cart to proceed.";
        this.showErrorMsgPopup(detailInfo);
        return;
    }

    if (this.isAnyItemInactive) {
      this.$toaster.pop('success', 'Some items in your cart are temporarily unavailable.  Please remove those items to continue with your purchase.');
      return false;
    }
    var $ctrl = this;
    this.$uibModal.open({
      size: 'md',
      template: `<div class="modal-body" id="modal-body">
            <div class="row">
              <div class="col-md-6">
                <button ng-if="isStoreActive" ng-click="ok()" ui-sref="guestdelivery" class="btn btn-primary btn-block btn-md-text">Continue as Guest</button>
                <div ng-if="!isStoreActive" class="error-text" ng-bind="errorMessage"></div>
                <button ng-if="!isStoreActive" class="btn btn-primary btn-block btn-md-text">Continue as Guest</button>
                <span>You can register an account later </span>
                <br/>
                <br/>
                <button type="button" class="btn btn-primary btn-block btn-sm-text mockup-btn" ng-click="ok()" 
                        ui-sref="signup({storeName: ` + $ctrl.storeURLName + `})">
                        <span>Register Now</span>
                        </button>
              </div>
              <div class="col-md-6" style="border-left: 1px solid #c1c1c1;">
                            <form class="login-form" name="loginForm"
                            ng-submit="submit(loginForm)"
                            autocomplete="off"
                            novalidate>
                        <div class="error-text" ng-bind="loginForm.error.message"></div>
                        <div class="form-group"
                            ng-class="{'has-danger': (loginForm.$submitted || loginForm.email.$touched) && loginForm.email.$invalid }">
                          <label>Email&nbsp<span><a href="#" tooltips tooltip-template="Daily Savings Club Members must register with the same email address that is associated with the 'in-store' account in order to receive membership benefits. If you do not know which email address was provided, please contact the store." tooltip-size="small" tooltip-smart="true" tooltip-class="info-tooltip" tooltip-side="right">
                          <img src="` + $ctrl.info + `" alt="info"></a></span></label>
                          <input name="email"
                                type="email"
                                ng-pattern="/^([A-Za-z0-9._-]+@[A-Za-z-0-9_-]+\.[A-Za-z]{2,}|[A-Za-z0-9._-]+@[A-Za-z0-9_-]+\.[A-Za-z0-9_-]*\.[A-Za-z]{2,}|[A-Za-z0-9._-]+@[A-Za-z0-9_-]+\.[A-Za-z0-9_-]*\.[A-Za-z]{2,}\.[A-Za-z]{2,})$/"
                                class="form-control"
                                ng-model="login.email"
                                required>
                          <div ng-messages="loginForm.email.$error"
                              class="form-control-feedback"
                              ng-show="loginForm.email.$touched || loginForm.$submitted">
                            <div ng-message="required">Enter email address</div>
                            <div ng-message="pattern">Enter a valid email address</div>
                            <div ng-message="email">Enter a valid email address</div>
                            <div class="error-text"
                                ng-show="loginForm.errors.email && !loginForm.email.$error.required && !loginForm.email.$error.pattern">{{ loginForm.errors.email[0] }}</div>
                          </div>
                        </div>
                        <div class="form-group"
                            ng-class="{'has-danger': (loginForm.$submitted || loginForm.password.$touched) && loginForm.password.$invalid }">
                          <label>Password</label>
                          <div class="password-container margin-ten">
                          <input name="password"
                                type="password"
                                class="form-control"
                                ng-model="login.password"
                                ng-minlength="6"
                                ng-maxlength="60"
                                id="passwordIdGuestCart"
                                required>
                            <i class="far fa-eye-slash" ng-click="togglePassword('passwordIdGuestCart','togglePasswordGuestCart')" id="togglePasswordGuestCart"
                            style="cursor: pointer;"></i>
                          </div>
                          <div ng-messages="loginForm.password.$error"
                              class="form-control-feedback"
                              ng-if="loginForm.password.$touched || loginForm.$submitted">
                            <div ng-message="required">Password is required</div>
                            <div ng-message="minlength">Minimum Password length should be 6</div>
                            <div ng-message="maxlength">Maximum Password length should be 60</div>
                            <div class="error-text"
                                ng-show="loginForm.errors.password && !loginForm.password.$error.required">{{ loginForm.errors.password[0] }}</div>
                          </div>
                        </div>
                      
                        <p class="text-xs-center gray-text mb-4">
                          By using this site, you agree to <a target="_blank" ng-click="ok()" ui-sref="tnc" class="link-text">Terms and Conditions</a> and <a target="_blank" ui-sref="rules" class="link-text">Rules</a>.
                        </p>
                      
                        <button type="submit"
                                class="btn btn-primary btn-block login-margin btn-sm-text mockup-btn">Log in</button>
                      
                        <p class="mt-4 m-b-1">
                          <a ui-sref="forgotPassword" ng-click="ok()" class="link-text gray-text">Forgot Password?</a>
                        </p>
                      
                      </form>
              </div>
            </div>
        </div>
        <div class="modal-footer">
            <button class="btn btn-primary" type="button" ng-click="ok()">Cancel</button>
        </div>`,
      controller: ['$scope', 'orderService', '$uibModalInstance',
        function ($scope, $order, $uibModalInstance) {

          $scope.isStoreActive = $ctrl.storeDetail.isActive;
          if (!$scope.isStoreActive) {
            $scope.errorMessage = "Your store is currently undergoing maintenance.  Please try again, or contact the store at ("
              + $ctrl.storeDetail.phoneNumber.substring(0, 3) + " ) " + $ctrl.storeDetail.phoneNumber.substring(3, 6) + " - " +
              $ctrl.storeDetail.phoneNumber.substring(6, 10);
          }

          $scope.togglePassword = (passwordId,toggleId) => {
            $ctrl.$auth.togglePassword(passwordId,toggleId);
          };

          $scope.ok = () => {
            if (!$scope.isStoreActive) {
              $scope.errorMessage = "Your store is currently undergoing maintenance.  Please try again, or contact the store at ("
                + $ctrl.storeDetail.phoneNumber.substring(0, 3) + " ) " + $ctrl.storeDetail.phoneNumber.substring(3, 6) + " - " +
                $ctrl.storeDetail.phoneNumber.substring(6, 10);
              return false;
            }
            $uibModalInstance.close();
          };

          $scope.isScreenSmall = () => {
            if ($ctrl.$window.innerHeight < 300) return true;
          };

          $scope.submit = function (form) {
            if (form.$invalid) {
              return;
            }
            form.error = {};
            $ctrl.$spinner.show('appSpinner');
            $ctrl.$auth.registerLogin({
              email: form.email.$viewValue,
              password: form.password.$viewValue
            })
              .then(
                success => {
                  $ctrl.$spinner.hide('appSpinner');
                  $uibModalInstance.close();
                  $ctrl.$rootScope.$emit('loginFromPopup', success);
                },
                error => {
                  $ctrl.$spinner.hide('appSpinner');
                  if (error.data.errorCode === 621) {
                    $uibModalInstance.close();
                    $ctrl.$state.go('inactive');
                  }
                  else {
                    form.error = error.data;
                  }
                })
                .catch(err => {
                  this.$auth.printCustomerGenericLogs(err);
                });
          };
        }
      ]
    });
  }

  getRetailPrice(quantity, price) {
    return quantity * price;
  }

  getClubDiscount(quantity, price) {
    return this.getRetailPrice(quantity, price) - this.getDiscountedPrice(quantity, price);
  }

  getDiscountedPrice(quantity, price) {
    return quantity * (Math.round((0.85 * price) * 100) / 100);
  }

  goToHomePage() {
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      this.$window.location.href = '/' + storeName;
    } else {
      this.$state.go('home');
    }
  }

  getMaxItemDiscount(discount, price) {
    return (Math.round((discount * price / 100) * 100) / 100);
  }

  totalRetailPrice() {
    return this.detail.cartItems.map(item => item.item.price * item.quantity)
      .reduce((prev, curr) => prev + curr);
  }

  getSavedAmount() {
    return this.getSubtotal() - this.getDSCAmount();
  }

  getDSCAmount() {
    let totalPrice = 0;
    let dscItems = this.detail.cartItems.filter(item => item.subCategory.category.dscCategory);
    let dscTotal = dscItems.map(item => (Math.round((0.85 * item.item.price) * 100) / 100) * item.quantity)
      .reduce((prev, curr) => prev + curr, 0);
    let nondscItems = this.detail.cartItems.filter(item => !item.subCategory.category.dscCategory);
    let nonDscTotal = nondscItems.map(item => item.item.price * item.quantity)
      .reduce((prev, curr) => prev + curr, 0);
    totalPrice = dscTotal + nonDscTotal;
    return totalPrice;
  }

  getSubtotal() {
    let totalPrice = 0;
    if (this.isErplyStore) {
      totalPrice = this.detail.erplyShopCartResponse.subTotal;
    } else {
      totalPrice = this.totalRetailPrice();
    }
    return totalPrice;
  }

  getTotalSaving() {
    return this.totalRetailPrice() - this.getSubtotal();
  }

  getDscPoints() {
    return this.getSubtotal();
  }

  updateItemInCart(quantity, item) {
    const guestCartItems = this.guestCartList.map(element => {
      if (element.itemId === item.item.id) {
        element.quantity = quantity;
      }
      return element;
    });
    if (guestCartItems) {
      this.$auth.updatetoGuestCart(guestCartItems);
      this.$auth.getGuestCart();
      setTimeout(() => {
        this.getGuestCartDetails();
      }, 1000);
    }
  }

  removeItemFromCart(itemId) {
    const cartItem = this.guestCartList.find(element => element.itemId === itemId);
    if (cartItem) {
      this.$auth.removetoGuestCart(cartItem.itemId);
      // Check Freeitem and buxgety
      const freeItem = this.detail.cartItems.find(ele => (ele.discountTypeApplied === 'FREEITEM' || ele.discountTypeApplied === 'BUYXGETY') && ele.isDiscountApplied);
      if (freeItem && freeItem.item.id === itemId) {
        sessionStorage.removeItem('discountCoupon');
        const guestCartDeliveryRequest = sessionStorage.getItem('GuestCartRequest') ? JSON.parse(sessionStorage.getItem('GuestCartRequest')) : null;
        guestCartDeliveryRequest.manualPromotionIDs = [];
        sessionStorage.setItem('GuestCartRequest', JSON.stringify(guestCartDeliveryRequest));
      }
      this.$auth.getGuestCart();
      this.getGuestCartDetails();
    }
  }

  isDscMember() {
    if (!(this.profile && this.profile.customer)) return false;
    return this.profile.customer.dscId === 'C' && new Date() <= new Date(this.profile.customer.dscExpireDate);
  }

  isDscButExpired() {
    if (!this.profile.customer) return false;
    return this.profile.customer.dscId === 'C' && new Date() > new Date(this.profile.customer.dscExpireDate);
  }

  canUserJoin() {
    return (!(this.isDscMember() || this.isDscButExpired()));
  }

  cartContainsDsc() {
    const arr = this.detail ? this.detail.cartItems.filter(item => item.item.masterProduct.masterCode === this.dscMasterCode) : [];
    return (arr.length === 1);
  }

  goToDetailPage(item) {
    if (this.isItemDscMembership(item)) {
      this.$state.go('savings-club');
    }
    else {
      let storeName = '';
      if (this.$stateParams.storeName) {
        storeName = this.$stateParams.storeName;
      }
      else {
        if (this.profile.store && this.profile.store.storeName) {
          storeName = this.profile.store.storeURLName;
        } else {
          storeName = this.$auth.getGuestStoreDetail().storeName;
        }
      }
      // let storeName =  false;
      if (storeName) {
        this.$state.go('browse-product.detail', {
          categoryId: item.item.masterProduct.category.prettyUrl,
          subCategoryId: item.item.masterProduct.subCategories[0].prettyUrl,
          productId: item.item.masterProduct.prettyUrl,
          itemGroupNumber: item.item.masterProduct.itemGroupNumber,
          storeName: storeName
        });
      }
      else {
        this.$state.go('browse-product.detail', {
          categoryId: item.item.masterProduct.category.prettyUrl,
          subCategoryId: item.item.masterProduct.subCategories[0].prettyUrl,
          productId: item.item.masterProduct.prettyUrl,
          itemGroupNumber: item.item.masterProduct.itemGroupNumber
        });
      }
    }
  }

  isItemDscMembership(item) {
    return item.item.masterProduct.masterCode === this.dscMasterCode;
  }

  isItemActive(item) {
    return (item.item.isActive && item.item.masterProduct.isActive && (item.item.price >= item.item.regionalPrice) && !item.item.isOutOfStock);
  }

  isFreeShippingOfferAvailable() {
    const store = (this.profile && this.profile.store) || this.storeDetail;
    if (store && this.detail.freeshipping) {
      var shippingOfferStartDate = new Date(this.detail.freeshipping.startDate);
      var shippingOfferEndDate = new Date(this.detail.freeshipping.endDate);
      var currentDate = new Date();
      var result = false;
      if (store) {
        if (store.isFreeShipping) {
          if (currentDate >= shippingOfferStartDate && currentDate <= shippingOfferEndDate) {
            result = true;
          }
        }
      }
    }
    return result;
  }

  shippingGrossPrice() {
    var totalGiftCardAmountPurchasing = 0.00;
    var $ctrl = this;
    angular.forEach(this.detail.cartItems, function (item, key) {
      if (item.item.masterProduct.category.id === $ctrl.isMiscelleneousCategory &&
        item.item.masterProduct.masterCode.charAt(0) === $ctrl.giftCardMasterCodeStartsWith) {
        totalGiftCardAmountPurchasing = totalGiftCardAmountPurchasing + (item.item.price * item.quantity);
      }
    });
    if (this.isErplyStore) {
      return this.getSubtotal() - totalGiftCardAmountPurchasing;
    } else {
      return this.getSubtotal() - totalGiftCardAmountPurchasing - (this.detail && this.detail.shopCartResponse && this.detail.shopCartResponse.promoDiscount ? this.detail.shopCartResponse.promoDiscount : 0);
    }
  }

  getFreeShippingRemainingAmount() {
    if (this.detail) {
      if (this.detail.freeshipping) {
        this.shippingOffer.thresholdAmount = this.detail.freeshipping.thresholdValue;
      }
    }
    let remainingAmount = this.shippingGrossPrice() - this.shippingOffer.thresholdAmount;
    if (remainingAmount >= 0) {
      this.shippingOffer.isOfferEligible = true;
    }
    else {
      this.shippingOffer.isOfferEligible = false;
    }
    return remainingAmount * -1;
  }

  showFreeShippingOfferDetail() {
    var $ctrl = this;
    var detailInfo, tittle = '';
    if ($ctrl.shippingOffer.isOfferEligible) {
      detailInfo = '<p><ul><li>Offer available within Zone 2 shipping, approximately 150 miles from store. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to U.S. Addresses only.</li><li>Offer is valid on all orders with a subtotal of $' + $ctrl.shippingOffer.thresholdAmount + ' or more after any other discounts applied.</li></ul></p>';
      tittle = 'Free Shipping within Zone 2';
    }
    else {
      tittle = 'Free Shipping within Zone 2';
      detailInfo = '<p><ul><li>Offer available within Zone 2 shipping, approximately 150 miles from store. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to U.S. Addresses only.</li><li>Offer is valid on all orders with a subtotal of $' + $ctrl.shippingOffer.thresholdAmount + ' or more after any other discounts applied.</li></ul></p>';
    }
    this.$uibModal.open({
      size: 'sm',
      template: '<div class="modal-body" id="modal-body">' +
        '<h5 class="font-weight-bold">' + tittle + '</h5>' +
        detailInfo +
        '</div>' +
        '<div class="modal-footer">' +
        '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' +
        '</div>',
      controller: ['$scope', 'orderService', '$uibModalInstance',
        function ($scope, $order, $uibModalInstance) {

          $scope.ok = () => {
            $uibModalInstance.close();

          };

        }
      ]
    });
  }

  showFreeShippingOfferDetailCan() {
    var $ctrl = this;
    var detailInfo, tittle = '';
    if ($ctrl.shippingOffer.isOfferEligible) {
      detailInfo = '<p><ul><li>Offer is valid within Zones 0-1 as defined by FedEx. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to Canadian addresses only</li><li>Offer is valid on all orders with a subtotal of $' + $ctrl.shippingOffer.thresholdAmount + ' or more after any other discounts applied.</li></ul></p>';
      tittle = 'Free shipping in Zones 0-1';
    }
    else {
      tittle = 'Free shipping in Zones 0-1';
      detailInfo = '<p><ul><li>Offer is valid within Zones 0-1 as defined by FedEx. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to Canadian addresses only</li><li>Offer is valid on all orders with a subtotal of $' + $ctrl.shippingOffer.thresholdAmount + ' or more after any other discounts applied.</li></ul></p>';
    }
    this.$uibModal.open({
      size: 'sm',
      template: '<div class="modal-body" id="modal-body">' +
        '<h5 class="font-weight-bold">' + tittle + '</h5>' +
        detailInfo +
        '</div>' +
        '<div class="modal-footer">' +
        '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' +
        '</div>',
      controller: ['$scope', 'orderService', '$uibModalInstance',
        function ($scope, $order, $uibModalInstance) {

          $scope.ok = () => {
            $uibModalInstance.close();

          };

        }
      ]
    });
  }

  isDscAddedinCart() {
    return this.detail.cartItems.some(function (cartItem) {
      return cartItem.item.storeItemCode === 'C';
    });
  }

  deliveryTypeValidation() {
    if (this.detail && this.detail.cartItems && this.detail.cartItems.length) {
      const pickupExist = this.detail.cartItems.filter(element => element.item.deliveryType == 'InStore');
      const dropExist = this.detail.cartItems.filter(element => element.item.deliveryType == 'DropShip');
      if (pickupExist && pickupExist.length && dropExist && dropExist.length) {
        return true;
      }
    }
    return false;
  }

  getFinalPriceInfo(item) {
    if (this.detail != null) {
      if (this.detail.erplyShopCartResponse != null && this.detail.erplyShopCartResponse.erplyItemDetails) {
        if (this.detail.erplyShopCartResponse.erplyItemDetails[item.item.storeItemCode]) {
          return this.detail.erplyShopCartResponse.erplyItemDetails[item.item.storeItemCode].finalPriceOfItem;
        }
      }
    }
  }

  getCouldSaveDSCAmount() {
    return this.detail.erplyShopCartResponse.originalPriceTotal - this.getDSCAmount();
  }

  isCartHasDSCItems() {
    let dscItems = this.detail.cartItems.filter(item => item.subCategory.category.dscCategory);
    if(dscItems.length>0){
      return true;
    }else{
      return false;
    }
  }

  getAdjustedLabelName(promoLabel) {
    if(promoLabel!=null && promoLabel.length>this.promoLengthToBeShown){
      return promoLabel.substring(0, this.promoLengthToBeShown-3)+"...";
    } else {
      return promoLabel;
    }
  }

  hideinfoPopup(prefix,index,itemName, promoName) {
    var divId = "";
    if(itemName!=null){
      divId = prefix+''+index+''+itemName+''+promoName;
    } else {
      divId =prefix+''+index+''+ promoName;
    }
    document.getElementById(divId).style.display = 'none';
    this.showPopup = false;
  }

  infoPopuponhover(prefix,index, itemName, promoName) {
    var divId = "";
    if(itemName!=null){
      divId = prefix+''+index+''+itemName+''+promoName;
    } else {
      divId =prefix+''+index+''+ promoName;
    }
    document.getElementById(divId).style.display = 'block';
    this.showPopup = true;
  }

  showErrorMsgPopup(detailInfo){
      this.$uibModal.open( {
        size: 'sm',
        template: '<div class="modal-body" id="modal-body">' +
        '<h5 class="font-weight-bold"> </h5>' +
        detailInfo +
        '</div>' +
        '<div class="modal-footer">' +
        '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' +
        '</div>',
        controller: ['$scope', 'orderService', '$uibModalInstance',
          function($scope, $order, $uibModalInstance) {
  
            $scope.ok = () => {
              $uibModalInstance.close();
            };
  
          }
        ]
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/order/cart/guestCart.js